const constants = {
  LEVEL: 'Level: ',
  MOVES_LEFT: 'MOVES LEFT',
  NEXT_LEVEL: 'Next level (n)',
  RESTART_THIS_LEVEL: 'Restart this level (r)',
  RESTART_GAME: 'Restart game (q)',
  YOU_WIN: 'You win!',
  YOU_LOOSE: 'You loose!'
};
export default constants;
